/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_UnderstandingInputs */

const en_directory_agent_readiness_understanding = /** @type {(inputs: Directory_Agent_Readiness_UnderstandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understanding`)
};

const zh_directory_agent_readiness_understanding = /** @type {(inputs: Directory_Agent_Readiness_UnderstandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理解能力`)
};

/**
* | output |
* | --- |
* | "Understanding" |
*
* @param {Directory_Agent_Readiness_UnderstandingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_understanding = /** @type {((inputs?: Directory_Agent_Readiness_UnderstandingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_UnderstandingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_understanding(inputs)
	return zh_directory_agent_readiness_understanding(inputs)
});
export { directory_agent_readiness_understanding as "directory.agent_readiness.understanding" }